import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

type Props = {
  size ?: number,
  color ?: string,
  zIndex ?: number,
  customLoadingClassName ?: string
  customStyle ?: React.CSSProperties
}

const GLoading = ({ size = 14, color, customLoadingClassName, zIndex, customStyle } : Props) => (
  <div
    className={'pos-rel w-100 m-5 ' + (customLoadingClassName || '')}
    style={{ minHeight: size * 1.2, zIndex: zIndex || 1000, ...(customStyle) }}
  >
    <div style={{ fontSize: (size || 14), color: color || '' }} className="tennders-loading">
      <FontAwesomeIcon icon={faSpinner} spin fontSize={size || 14} style={{ maxWidth: `${size}px` }} size="sm" />
    </div>
  </div>

)

export default React.memo(GLoading)
